export default "__VITE_ASSET__CNfi_6PF__"